import { UserInterface, UserRoles } from 'auth0/types';

export const isTalent = (user: UserInterface) =>
  user?.['https://opentalent.co']?.user_roles?.includes(UserRoles.Talent);
export const isCompany = (user: UserInterface) =>
  user?.['https://opentalent.co']?.user_roles?.includes(UserRoles.Company);
